module.exports = __webpack_public_path__ + "img/37c9e0180da8f37f11c5ffb758c062e.a24d2629.png";